import { $qs, $qsa } from '../utils/QuerySelector';
import { media } from '../utils/MediaQueries';
import nestedLinesSplit from '../utils/NestedLinesSplit';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { EffectFade, Pagination, Autoplay } from 'swiper';
import preloader from '../components/preloader';

gsap.registerPlugin(ScrollTrigger);



function banner() {
    // create a timeline for each slide
    // each slide timeline should fade the slide in, then fade the characters of the text in, then fade the slide out
    // each timeline should overlap, so the second slide starts fading in when the first slide starts fading out
    // this should be done with a repeatDelay on the timeline, so that they all run at the same, but don't start until the previous one has finished
    // this should fix the issue with the above commented out code, where the first and last slides don't overlap
    
    const slides = $qsa('[data-target="banner-slide"]');
    const calcTimelines = [];
    const timelines = [];
    const slideFadeDuration = 1;

    slides && [...slides].forEach((slide, index) => {
        const quoteText = $qs('[data-target="banner-quote-text"]', slide);
        const quoteCitation = $qs('[data-target="banner-quote-citation"]', slide);
        const splitQuoteText = nestedLinesSplit(quoteText, {
            type: 'chars,words,lines',
        });

        const timeline = gsap.timeline({
            paused: true
        });

        timeline
            .to(slide, {
                autoAlpha: 1,
                duration: slideFadeDuration,
                ease: 'none'
            })
            .from(splitQuoteText.chars, {
                autoAlpha: 0,
                duration: 0.5,
                stagger: 0.11,
                ease: 'none'
            });

        if (quoteCitation) {
            timeline
                .to(quoteCitation, {
                    autoAlpha: 1,
                    duration: 0.5,
                    ease: 'none'
                }, '-=0.25');
        }

        timeline
            .to(slide, {
                autoAlpha: 0,
                duration: slideFadeDuration,
                ease: 'none'
            }, '+=0.5');

        calcTimelines.push(timeline);

        splitQuoteText.revert();
    });

    slides && [...slides].forEach((slide, index) => {
        const quoteText = $qs('[data-target="banner-quote-text"]', slide);
        const quoteCitation = $qs('[data-target="banner-quote-citation"]', slide);
        const splitQuoteText = nestedLinesSplit(quoteText, {
            type: 'chars,words,lines',
        });

        const delay = calcTimelines.slice(0, index).reduce((acc, curr) => acc + curr.duration() - slideFadeDuration, 0);
        const allOtherCalcTimelines = calcTimelines.filter((timeline, i) => i !== index);
        const repeatDelay = allOtherCalcTimelines.reduce((acc, curr) => acc + curr.duration(), 0) - (slideFadeDuration * calcTimelines.length);

        const timeline = gsap.timeline({
            paused: true,
            delay: delay,
            repeat: -1,
            repeatDelay: repeatDelay
        });

        timeline
            .to(slide, {
                autoAlpha: 1,
                duration: slideFadeDuration,
                ease: 'none'
            })
            .from(splitQuoteText.chars, {
                autoAlpha: 0,
                duration: 0.5,
                stagger: 0.11,
                ease: 'none'
            });

        if (quoteCitation) {
            timeline
                .to(quoteCitation, {
                    autoAlpha: 1,
                    duration: 0.5,
                    ease: 'none'
                }, '-=0.25');
        }

        timeline
            .to(slide, {
                autoAlpha: 0,
                duration: slideFadeDuration,
                ease: 'none'
            }, '+=0.5');

        timelines.push(timeline);
    });

    return timelines;
}

function setBannerHeightMobile() {
    const banner = $qs('[data-name="banner"]');
    const bannerSlides = $qsa('[data-target="banner-slide"]', banner);
    const tallestBannerSlideHeight = Math.max(...[...bannerSlides].map(slide => slide.offsetHeight));

    banner.style.height = `${tallestBannerSlideHeight}px`;
    banner.dataset.settled = 'true';
}

function video() {
    const section = $qs('[data-name="video"]');
    const video = $qs('[data-target="video"]', section);

    gsap.to(video, {
        scrollTrigger: {
            trigger: section,
            scrub: true,
            start: '10% bottom',
            end: 'bottom bottom',
            // markers: true
        },
        scale: 1,
        ease: 'none'
    });
}


function scrollingText() {
    const section = $qs('[data-name="scrolling-text"]');
    const scrollingTextContainer = $qs('[data-target="scrolling-text-container"]', section);
    const scrollingTextWrappers = $qsa('[data-target="scrolling-text"]', section);
    const horizontalPadding = 128;

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: scrollingTextContainer,
            scrub: true,
            start: 'top bottom',
            end: 'bottom top',
            // markers: true
        }
    });

    timeline.addLabel('start');

    [...scrollingTextWrappers].forEach((wrapper, index) => {
        const width = wrapper.offsetWidth;

        if (index === 0) {
            timeline.fromTo(wrapper, {
                x: `${horizontalPadding}px`,
                ease: 'none'
            }, {
                x: `-${width - window.innerWidth + horizontalPadding}`,
                ease: 'none'
            }, 'start');
        } else {
            timeline.fromTo(wrapper, {
                x: `-${width - window.innerWidth + horizontalPadding}`,
                ease: 'none'
            }, {
                x: `${horizontalPadding}px`,
                ease: 'none'
            }, 'start');
        }
    });
}

async function imageReveals() {
    const imageContentSection = $qs('[data-name="image-content-scroll"]');
    const imageContentImage = $qs('[data-target="image"]', imageContentSection);
    const imageContentText = $qs('[data-target="text"]', imageContentSection);

    const imageContentBgImg = $qs('[data-name="image-content-scroll--bg-img"]');
    const imageContentScaleText = $qs('[data-name="image-content-scroll--text"]');
    const imageContentScaleTextLarge = $qs('[data-name="text--large"]', imageContentSection);
    const imageContentScaleTextSmall = $qs('[data-name="text--small"]', imageContentSection);
   


    if ( media.lg ) {
      const scrollWrapper = gsap.timeline({
        ease: 'none',
        scrollTrigger: {
          trigger: imageContentSection,
          pin: true,
          pinSpacing: true,
          scrub: true,
          start: "top top",
          end: "300% top",
        }
      });
  
      scrollWrapper.fromTo( imageContentScaleText, { opacity: 0 }, { opacity: 1, duration: 1.2 }, "<" );
      scrollWrapper.fromTo( imageContentScaleText, { scaleX: 1, scaleY: 1 }, { scaleX: 6, scaleY: 6, duration: 1.6 }, ">+=0.2" );
      scrollWrapper.fromTo( imageContentScaleTextLarge, { opacity: 1 }, { opacity: 0, duration: 0.8 }, ">-=0.6" );
      scrollWrapper.fromTo( imageContentScaleTextSmall, { opacity: 1 }, { opacity: 0, duration: 0.8 }, ">+=0.3" );
      scrollWrapper.to( imageContentBgImg, { opacity:0, duration: 0.8  }, ">-=0.1" );
      scrollWrapper.from(imageContentImage, { y: '130%', ease: 'none', duration: 1.4 }, ">-=0.9" );
      scrollWrapper.from(imageContentText, { autoAlpha: 0, ease: 'none', duration: 1.1  }, '>-=0.9');
 
    } else {
      const textAndImageTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: imageContentSection,
            start: 'center bottom',
            end: 'center center',
            scrub: true,
            markers: false
        }
      });

      textAndImageTimeline
        .from(imageContentImage, {
            clipPath: 'inset(0% 0% 0% 100%)',
            ease: 'none'
        })
        .from(imageContentText, {
            autoAlpha: 0,
            ease: 'none'
        }, '-=0.5');
    }


}

function sliders() {
    // alumni success slider
    const alumniSuccessSlider = $qs('[data-target="home-alumni-success-slider"]');
    const alumniSuccessSwiper = new Swiper(alumniSuccessSlider, {
        modules: [EffectFade, Pagination, Autoplay],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    });

    // news slider
    const newsSlider = $qs('[data-target="home-news-slider"]');
    const newsSwiper = new Swiper(newsSlider, {
        modules: [EffectFade, Pagination, Autoplay],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    });

    // logo slider
    const logoSlider = $qs('[data-target="home-logo-slider"]');
    const logoSwiper = new Swiper(logoSlider, {
        modules: [EffectFade, Pagination, Autoplay],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    });
}

function Home() {
    if (!$qs('.page-template-tpl-home.blogid-1')) return;

    
    const preloaderTimeline = preloader();
    const bannerTimelines = banner();
    const firstBannerSlide = $qs('[data-target="banner-slide"]');

    // set first slide to be visible on load for preloader fade in animation
    gsap.set(firstBannerSlide, { autoAlpha: 1 });

    preloaderTimeline.add(() => {
        bannerTimelines.forEach(timeline => timeline.play());
    }, '-=1');

    // skip preloader for debugging
    // preloaderTimeline.progress(0.9);

    // skip preloader if already viewed in this session
    // if (sessionStorage.getItem('preloader_viewed') === 'true') {
    //     preloaderTimeline.progress(0.925);
    // }

    // check if localStorage variable "preloader_expiry_date" value is past the current date and skip to end if it isn't
    const preloaderExpiryDate = localStorage.getItem('preloader_expiry_date');
    const currentDate = new Date();
    const expiryDate = new Date(preloaderExpiryDate);
    
    
    if (expiryDate > currentDate) {
        preloaderTimeline.progress(0.925);
    }

    !media.lg && setBannerHeightMobile();
    media.lg && video();
    scrollingText();
    imageReveals();
    sliders();
 
}

export default Home;